
import { useParams } from 'react-router-dom';
import { ClientesFormState } from '../../../context/clientes/ClientesFormState';
import { Form } from './form';

export const ClientesFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Cliente" : "Crear Cliente";

  return (
    <ClientesFormState>
        <br />
        <Form title={title} />
    </ClientesFormState>
  );
};
